import React from 'react';
import { Link } from 'react-router-dom';

export default function LandingPage() {
  return (
    <div className="landing-page">
      <h1>Life Tracking Forms</h1>
      <div className="form-selection">
        <Link to="/mood-form" className="form-link">
          <div className="form-card">
            <h2>Mood Form</h2>
            <p>Track your mood, energy, and activities</p>
          </div>
        </Link>
        <Link to="/substances-form" className="form-link">
          <div className="form-card">
            <h2>Substances Form</h2>
            <p>Track your consumption of coffee, tea, and other substances</p>
          </div>
        </Link>
        <Link to="/custom-metric-form" className="form-link">
          <div className="form-card">
            <h2>Custom Metric Form</h2>
            <p>Track any custom metric with labels and values</p>
          </div>
        </Link>
      </div>
    </div>
  );
} 